export type ApplicationSettingsWebIntent = 'sourceCode' | 'businessContext';

export type ApplicationSettingsWebSubtab = 'knowledgeSources';

export const buildApplicationSettingsWebPath = ({
  applicationId,
  isAiApplication,
  intent,
  subtab,
}: {
  applicationId: string;
  isAiApplication: boolean;
  intent: ApplicationSettingsWebIntent;
  subtab?: ApplicationSettingsWebSubtab;
}): string => {
  const collection = isAiApplication ? 'ai-applications' : 'applications';
  const query = new URLSearchParams(
    subtab ? { intent, subtab } : { intent },
  ).toString();

  return `/${collection}/${encodeURIComponent(applicationId)}/settings?${query}`;
};
